// extracted by mini-css-extract-plugin
export default {"infinite":"styles_infinite__QWVAc"};